/**
 * Created by Sasha on 4/1/2019.
 */
import {
  Component , EventEmitter ,
  Input ,
  OnChanges , OnDestroy , OnInit , Output ,
} from '@angular/core';
import html2canvas from 'html2canvas';
import {NgxSpinnerService} from "ngx-spinner";

@Component({
    selector: 'simple-list',
    templateUrl: './simple-list.html',
    styleUrls: ['./simple-list.scss'],
    standalone: false
})
export class SimpleListComponent implements OnChanges , OnDestroy , OnInit {
  @Input() data;
  @Input() type;
  @Input() color;
  @Input() systemTyp;
  @Input() isTime;
  @Input() name;
  @Output() time = new EventEmitter();
  checked = true;
  view: any[];
  colorScheme: any;
  animations: boolean = true;

  constructor (private spinner: NgxSpinnerService) {
  }

  ngOnInit () {
  }


  ngOnChanges () {
    if (this.color && this.color.domain.length) {
      this.colorScheme = this.color;
    }
  }


  ngOnDestroy () {

  }

  changeTime () {
    this.time.emit(this.isTime);
  }
}
